import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LocaleItemProps } from "apis/locale";
import { PaginationProps } from "utils/types/API";

export interface LocaleState {
    loading: boolean;
    list: {
        data: LocaleItemProps[];
        options: LocaleItemProps[];
        pagination?: PaginationProps;
    };
    item: {
        data?: LocaleItemProps;
    };
}

const initialState: LocaleState = {
    loading: false,
    list: {
        data: [],
        options: []
    },
    item: {
    }
};

interface IndexProps {
    data: LocaleItemProps[];
    pagination?: PaginationProps;
}
interface ItemProps {
    data?: LocaleItemProps;
}
export const localeSlice = createSlice({
    name: "locale",
    initialState,
    reducers: {
        loading: (state) => {
            state.loading = true;
        },
        endLoading: (state) => {
            state.loading = false;
        },
        index: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.data = action.payload.data;
            state.list.pagination = action.payload.pagination;
        },
        options: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.options = action.payload.data;
        },
        find: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        create: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        update: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
            state.list.data = state.list.data.map(item => item.id === action.payload.data?.id ? action.payload.data : item);
        },
    },
});

export const { loading, endLoading, index, options, find, create, update } = localeSlice.actions;
export default localeSlice.reducer;
